import { useScreenSize } from "@/composables/useBreakpoint";

/**
 * Composable for loading responsive Lottie animations based on screen size
 * @param {Object} loaders - Object with sm, md, lg keys containing dynamic import functions
 * @returns {Object} - { current, load, screenSize }
 */
export function useResponsiveLottie(loaders) {
    const screenSize = useScreenSize();
    const current = ref(null);
    const cache = {};

    // Load Lottie dynamically
    const load = async () => {
        const size = screenSize.value;

        // Return from cache if available
        if (cache[size]) {
            current.value = cache[size];
            return;
        }

        try {
            const mod = await loaders[size]();
            cache[size] = mod.default;
            current.value = mod.default;
        } catch (error) {
            console.error("Failed to load Lottie animation:", error);
        }
    };

    // Debounce loading on resize
    let resizeTimer;
    watch(screenSize, () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(load, 300);
    });

    onBeforeUnmount(() => {
        clearTimeout(resizeTimer);
    });

    return { current, load, screenSize };
}
